import { CFormGroup, CInvalidFeedback, CLabel, CTextarea } from "@coreui/react";

import React from "react";
import { FieldError } from "react-hook-form";

interface TextAreaFieldProps {
  name: string;
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  error?: FieldError;
  required?: boolean;
  placeholder?: string;
  rows?: number;
  testId?: string;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  name,
  label,
  description,
  value,
  onChange,
  error,
  required = false,
  placeholder,
  rows = 3,
  testId,
}) => {
  return (
    <CFormGroup>
      <CLabel htmlFor={name}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </CLabel>
      {description && (
        <small className="form-text text-muted mb-2">{description}</small>
      )}
      <CTextarea
        id={name}
        name={name}
        data-testid={testId}
        value={value}
        onChange={(e) => onChange((e.target as HTMLTextAreaElement).value)}
        placeholder={placeholder}
        invalid={!!error}
        rows={rows}
      />
      {error && <CInvalidFeedback>{error.message}</CInvalidFeedback>}
    </CFormGroup>
  );
};

export default TextAreaField;
